<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          큐레이터 승인대기
        </div>
        <div>
          <member-list-component :memberType="`curator`"></member-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
  name: "CuratorApprove",
  mixins: [],
  components: {
    MemberListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>